import { Tag } from '@ontruck/orc';
import React from 'react';

export const isPrio = (shipper) => {
  const serviceLevel = shipper?.sales_attributes?.service_level || '';

  return ['HIGH'].includes(serviceLevel);
};

export const isFtb = (shipper) => {
  const { tags = [] } = shipper || {};
  return !!(tags || []).find(({ name }) => name === 'FTB');
};

export const isRecovering = (shipper) => {
  const RECOVERING_STATUS = 'RECOVERING';
  const LOST_STATUS = 'LOST';

  return (
    shipper?.sales_attributes?.recovering === RECOVERING_STATUS ||
    shipper?.sales_attributes?.recovering === LOST_STATUS
  );
};

export const shipperPotentialTag = (shipper) => {
  const { sales_attributes } = shipper || {};
  const { potential } = sales_attributes || {};

  if (!potential) {
    return null;
  }

  const tagOptions = {
    AAA: (
      <Tag skin="modernOrange" weight="bold" textTransform="uppercase" data-testid="potential_tag">
        AAA
      </Tag>
    ),
    A: (
      <Tag
        skin="modernLightGrey"
        weight="bold"
        textTransform="uppercase"
        data-testid="potential_tag"
      >
        A
      </Tag>
    ),
    B: (
      <Tag
        skin="modernLightGrey"
        weight="bold"
        textTransform="uppercase"
        data-testid="potential_tag"
      >
        B
      </Tag>
    ),
    C: (
      <Tag
        skin="modernLightGrey"
        weight="bold"
        textTransform="uppercase"
        data-testid="potential_tag"
      >
        C
      </Tag>
    ),
  };

  return tagOptions[potential] || null;
};

export const shipperFtbTag = (shipper) => {
  const { sales_attributes } = shipper || {};
  const { is_ftb } = sales_attributes || {};

  if (!is_ftb) return null;
  return (
    <Tag skin="modernGrey" weight="bold" textTransform="uppercase" data-testid="ftb_tag">
      NEW
    </Tag>
  );
};

export const shipperPrioTag = (shipper) => {
  if (!isPrio(shipper)) return null;

  return (
    <Tag skin="priority" weight="bold" textTransform="uppercase" data-testid="prio_tag">
      PRIO
    </Tag>
  );
};
